export default __webpack_public_path__ + "static/media/quitarDeOmitir.1b655d87.svg";